import React from 'react';
import styled from 'styled-components';

import { useCardContext } from './card-context';

/** Strain type pill and potency values (THC, CBD, TAC, TERPS). Renders nothing when both are absent. */
export function CardStrainDetails(): JSX.Element | null {
  const { strainType, potency } = useCardContext();

  if (!strainType && potency.length === 0) {
    return null;
  }

  return (
    <Details>
      {strainType && <Strain data-testid='card-strain'>{strainType}</Strain>}
      {potency.map((p) => (
        <PotencyItem key={p}>{p}</PotencyItem>
      ))}
    </Details>
  );
}

const Details = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 16px;
`;

const Strain = styled.div`
  background: #e3e7e9;
  border-radius: 12px;
  color: #2c3236;
  display: inline-block;
  font: 500 12px/1 ${({ theme }) => theme.customized.fonts.secondary};
  padding: 6px 8px;
`;

const PotencyItem = styled.span`
  color: #646d72;
  font: 12px/1 ${({ theme }) => theme.customized.fonts.secondary};
  white-space: nowrap;
`;
